import { useMemo } from 'react'
import * as Yup from 'yup'

import { useTranslation } from '../../../../app/_providers/TranslationProvider.client'
import { UseEmbroideryProps } from '../../../../containers/EmbroideryService'
import { allowedTextInputCharactersPattern } from '../../../../containers/EmbroideryService/utils'

export interface Props {
  textMaxChars: number
  textEmbroideryOptions?: UseEmbroideryProps['textEmbroideryOptions']
}

export const useValidationSchema = ({ textMaxChars, textEmbroideryOptions }: Props) => {
  const {
    embroidery: {
      modal: { forms: fixtures },
    },
  } = useTranslation()

  const validationSchema = useMemo(() => {
    return Yup.object().shape({
      __type: Yup.mixed().oneOf(['TextFormValues']),
      textColor: Yup.string().required(fixtures.validationErrorMessages.requiredNameColor),
      firstLine: Yup.string()
        .trim()
        .required(fixtures.validationErrorMessages.requiredName)
        .matches(
          allowedTextInputCharactersPattern,
          fixtures.validationErrorMessages.allowedTextCharacters
        )
        .max(
          textMaxChars,
          fixtures.validationErrorMessages.textMaxCharsTemplate.replace(
            '{{max}}',
            textMaxChars.toString()
          )
        ),
      font: Yup.object().shape({}).required(fixtures.validationErrorMessages.requiredFont),
      secondLine: Yup.string()
        .matches(
          allowedTextInputCharactersPattern,
          fixtures.validationErrorMessages.allowedTextCharacters
        )
        .max(
          textMaxChars,
          fixtures.validationErrorMessages.textMaxCharsTemplate.replace(
            '{{max}}',
            textMaxChars.toString()
          )
        )
        // Ensure that only the provided second line options are allowed, if defined
        .when({
          is: () => (textEmbroideryOptions?.secondLine ?? []).length > 0,
          then: Yup.string().oneOf(
            textEmbroideryOptions?.secondLine ?? [],
            'Second line must be a valid selection.'
          ),
        }),
      textPlacement: Yup.object()
        .shape({})
        .required(fixtures.validationErrorMessages.requiredNamePlacement),
    })
    // TODO: Fix this auto-generated suppression.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    fixtures.validationErrorMessages.allowedTextCharacters,
    fixtures.validationErrorMessages.requiredNameColor,
    fixtures.validationErrorMessages.requiredNamePlacement,
    fixtures.validationErrorMessages.requiredFont,
    fixtures.validationErrorMessages.requiredName,
  ])

  return validationSchema
}
